import overview from './overview';
import general from './general';
import production from './production';
import injection from './injection';
import disposition from './disposition';
import incidents from './incidents';
import rigs from './rigs';
import permits from './permits';
import completions from './completions';
import tests from './tests';
import fracinfo from './fracinfo';
import fracingredients from './fracingredients';
import casing from './casing';
import tubingandpacker from './tubingandpacker';
import perfs from './perfs';
import directional from './directional';
import formations from './formations';
import plugs from './plugs';
import plugandabandon from './plugandabandon';
import history from './history';
import contacts from './contacts';
import waterchemicals from './waterchemicals';
import userdata from './userdata';
import activity from './activity';


const items = [
    overview,
    general,
    production,
    injection,
    disposition,
    incidents,
    rigs,
    permits,
    completions,
    tests,
    fracinfo,
    fracingredients,
    casing,
    tubingandpacker,
    perfs,
    directional,
    formations,
    plugs,
    plugandabandon,
    history,
    contacts,
    waterchemicals,
    userdata,
    activity,
];

export {
    items,
}